<template>
    <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" :width="width" :height="height" version="1.1"
         style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
         viewBox="0 0 141 220"
         xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="Слой_x0020_1">
        <metadata id="CorelCorpID_0Corel-Layer"></metadata>
            <g :id="'top-left' + $vnode.key">
                <path class="paint-fill paint-stroke"
                      d="M46 11c-8,7 -14,17 -18,31 -3,12 -7,23 -10,34l28 0 0 -64z"></path>
                <text v-if="value['top-left']" x="30" y="170" font-family="Verdana" font-size="18" fill="#000000"
                      transform="rotate(90,100,100)">
                    {{value['top-left']}}
                </text>
                <foreignObject>
                    <paint-popover :save="value => emit('top-left', value)" :value="value['top-left']" :readonly="readonly"
                                   :target="'top-left' + $vnode.key"></paint-popover>
                </foreignObject>
            </g>
            <g :id="'top' + $vnode.key">
                <path class="paint-fill paint-stroke" d="M96 9c-14,-11 -34,-12 -50,2l0 64 50 0 0 -66z"></path>
                <text v-if="value['top']" x="13" y="135" font-family="Verdana" font-size="24" fill="#000000"
                      transform="rotate(90,100,100)">
                    {{value['top']}}
                </text>
                <foreignObject>
                    <paint-popover :save="value => emit('top', value)" :value="value['top']" :readonly="readonly"
                                   :target="'top' + $vnode.key"></paint-popover>
                </foreignObject>
            </g>
            <g :id="'top-right' + $vnode.key">
                <path class="paint-fill paint-stroke"
                      d="M127 75c-5,-15 -11,-31 -18,-49 -3,-7 -8,-13 -13,-17l0 66 31 0z"></path>
                <text v-if="value['top-right']" x="30" y="100" font-family="Verdana" font-size="18" fill="#000000"
                      transform="rotate(90,100,100)">
                    {{value['top-right']}}
                </text>
                <foreignObject>
                    <paint-popover :save="value => emit('top-right', value)" :value="value['top-right']" :readonly="readonly"
                                   :target="'top-right' + $vnode.key"></paint-popover>
                </foreignObject>
            </g>
            <g :id="'mid-left' + $vnode.key">
                <path class="paint-fill paint-stroke"
                      d="M19 75c-5,16 -10,32 -15,50 -3,11 -4,20 -2,28l45 0 0 -78 -28 0z"></path>
                <text v-if="value['mid-left']" x="90" y="180" font-family="Verdana" font-size="24" fill="#000000"
                      transform="rotate(90,100,100)">
                    {{value['mid-left']}}
                </text>
                <foreignObject>
                    <paint-popover :save="value => emit('mid-left', value)" :value="value['mid-left']" :readonly="readonly"
                                   :target="'mid-left' + $vnode.key"></paint-popover>
                </foreignObject>
            </g>
            <g :id="'mid' + $vnode.key">
                <rect class="paint-fill paint-stroke" x="46" y="75" width="50" height="78"></rect>
                <text v-if="value['mid']" x="90" y="135" font-family="Verdana" font-size="24" fill="#000000"
                      transform="rotate(90,100,100)">
                    {{value['mid']}}
                </text>
                <foreignObject>
                    <paint-popover :save="value => emit('mid', value)" :value="value['mid']" :readonly="readonly"
                                   :target="'mid' + $vnode.key"></paint-popover>
                </foreignObject>
            </g>
            <g :id="'mid-right' + $vnode.key">
                <path class="paint-fill paint-stroke" d="M96 153l44 0c0,-22 -4,-48 -13,-78l-31 0 0 78z"></path>
                <text v-if="value['mid-right']" x="90" y="95" font-family="Verdana" font-size="24" fill="#000000"
                      transform="rotate(90,100,100)">
                    {{value['mid-right']}}
                </text>
                <foreignObject>
                    <paint-popover :save="value => emit('mid-right', value)" :value="value['mid-right']" :readonly="readonly"
                                   :target="'mid-right' + $vnode.key"></paint-popover>
                </foreignObject>
            </g>
            <g :id="'bottom-left' + $vnode.key">
                <path class="paint-fill paint-stroke" d="M1 153c4,17 19,29 44,46 0,0 1,0 1,1l0 -46 -45 0z"></path>
                <text v-if="value['bottom-left']" x="155" y="177" font-family="Verdana" font-size="18" fill="#000000"
                      transform="rotate(90,100,100)">
                    {{value['bottom-left']}}
                </text>
                <foreignObject>
                    <paint-popover :save="value => emit('bottom-left', value)" :value="value['bottom-left']" :readonly="readonly"
                                   :target="'bottom-left' + $vnode.key"></paint-popover>
                </foreignObject>
            </g>
            <g :id="'bottom'+ $vnode.key">
                <path class="paint-fill paint-stroke"
                      d="M87 216c3,-2 6,-4 9,-6l0 -57 -50 0 0 46c9,7 21,29 41,17z"></path>
                <text v-if="value['bottom']" x="155" y="136" font-family="Verdana" font-size="24" fill="#000000"
                      transform="rotate(90,100,100)">
                    {{value['bottom']}}
                </text>
                <foreignObject>
                    <paint-popover :save="value => emit('bottom', value)" :value="value['bottom']" :readonly="readonly"
                                   :target="'bottom' + $vnode.key"></paint-popover>
                </foreignObject>
            </g>
            <g :id="'bottom-right' + $vnode.key">
                <path class="paint-fill paint-stroke"
                      d="M96 210c8,-7 13,-13 19,-16 17,-8 23,-14 24,-28 0,-4 1,-9 1,-13l-44 0 0 57z"></path>
                <text v-if="value['bottom-right']" x="155" y="90" font-family="Verdana" font-size="18" fill="#000000"
                      transform="rotate(90,100,100)">
                    {{value['bottom-right']}}
                </text>
                <foreignObject>
                    <paint-popover :save="value => emit('bottom-right', value)" :value="value['bottom-right']" :readonly="readonly"
                                   :target="'bottom-right' + $vnode.key"></paint-popover>
                </foreignObject>
            </g>
        </g>
    </svg>
</template>

<script>
    import {implantMixin} from '@/mixins/implant.js'
    import PaintPopover from "./PaintPopover";

    export default {
        components: {PaintPopover},
        props: {value: {type: Object, default: () => ({})}},
        mixins: [implantMixin],
        methods: {
            emit(partSelected, value) {
                let localValue = this.$copy(this.value);
                localValue[partSelected] = value;
                this.$emit('input', localValue);
                this.$emit('change', localValue);
            }
        }
    }
</script>

<style lang="scss" scoped>
    svg {
        margin: 0;
    }

    .paint-stroke {
        stroke: #c1c1c1;
        stroke-width: 4;
        stroke-miterlimit: 10;
    }

    .fill-black {
        fill: #0d1b2b;
    }

    .paint-fill {
        fill: #ffffff;
        stroke: #ccc;
        stroke-width: 2;
    }

    .paint-fill:hover {
        stroke: #f6c343;
        stroke-width: 2;
        /* zoom: 10; */
    }

    .paint-active {
        stroke: red;
        stroke-dasharray: 0;
    }
</style>
